module.exports = __webpack_public_path__ + "static/thanx-customise-301e633b23987af218a1041c40bb7ebb.png";